export default __webpack_public_path__ + "static/media/clock.2ec26239.png";